import React from 'react';
import LogoImg from "./images/logo.png";
import './css/footer.css';
import { useLanguage } from '../context/LanguageContext';
import { SiSnapchat, SiFacebook, SiTelegram } from 'react-icons/si';

const Footer = () => {
  const { t, currentLanguage } = useLanguage();
  
  const handleDownloadEnglishProfile = (e) => {
    e.preventDefault();
    
    // Use fetch to force download in all browsers including Safari
    fetch('/profile/English (1).pdf')
      .then(response => response.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.download = 'Etqan_Vision_Company_Profile_English.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch(() => {
        // Fallback to direct link if fetch fails
        const link = document.createElement('a');
        link.href = '/profile/English (1).pdf';
        link.download = 'Etqan_Vision_Company_Profile_English.pdf';
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
  };

  const handleDownloadArabicProfile = (e) => {
    e.preventDefault();
    
    // Use fetch to force download in all browsers including Safari
    fetch('/profile/Arabic.pdf')
      .then(response => response.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.download = 'Etqan_Vision_Company_Profile_Arabic.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch(() => {
        // Fallback to direct link if fetch fails
        const link = document.createElement('a');
        link.href = '/profile/Arabic.pdf';
        link.download = 'Etqan_Vision_Company_Profile_Arabic.pdf';
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
  };
  return (
    <footer>
        <div className='container'>
            <div className='row'>
                <div className='col-lg-6 col-md-6 col-12'>
                    <div className='logo'>
                        <img src={LogoImg} alt="logo" />
                    </div>
                    <div className='social-links social-desktop' aria-label="Social media links">
                        <ul>
                            <li>
                                <a href="https://www.youtube.com/@EtqanvisionEtqanvision" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                        <path d="M23.5 6.2a4 4 0 0 0-2.8-2.8C18.9 3 12 3 12 3s-6.9 0-8.7.4A4 4 0 0 0 .5 6.2 41.6 41.6 0 0 0 0 12c0 5.8.5 5.8.5 5.8a4 4 0 0 0 2.8 2.8C5.1 21 12 21 12 21s6.9 0 8.7-.4a4 4 0 0 0 2.8-2.8c.4-1.8.5-3.8.5-5.8 0-2-.1-4-.5-5.8Z" fill="currentColor"/>
                                        <path d="M9.75 15.02V8.98L15.5 12l-5.75 3.02Z" fill="#fff"/>
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.snapchat.com/add/etqanvision?share_id=fOX2-g_LNcc&locale=en-US" target="_blank" rel="noopener noreferrer" aria-label="Snapchat">
                                    <SiSnapchat size={22} aria-hidden="true" />
                                </a>
                            </li>
                            <li>
                                <a href="https://www.instagram.com/etqanvision" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                        <rect x="3" y="3" width="18" height="18" rx="5" stroke="currentColor" strokeWidth="2"/>
                                        <circle cx="12" cy="12" r="3.5" stroke="currentColor" strokeWidth="2"/>
                                        <circle cx="17.5" cy="6.5" r="1.2" fill="currentColor"/>
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <a href="http://tiktok.com/@etqan.vision.etqa" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
                                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                        <path d="M14.5 3v3.2c1.3 1.1 2.9 1.7 4.6 1.7v3a8.7 8.7 0 0 1-4.6-1.4v5.7a5.7 5.7 0 1 1-5.7-5.7c.4 0 .8 0 1.1.1V12a2.7 2.7 0 1 0 1.6 2.5V3h3Z" fill="currentColor"/>
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.facebook.com/profile.php?id=61580097365636" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                                    <SiFacebook size={22} aria-hidden="true" />
                                </a>
                            </li>
                            <li>
                                <a href="https://t.me/Etqanvision" target="_blank" rel="noopener noreferrer" aria-label="Telegram">
                                    <SiTelegram size={22} aria-hidden="true" />
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className='col-lg-2 col-md-2 col-12'>
                    <div className='short-links'>
                        <ul>
                            <li>
                                <a href="#" className="active">
                                    {t('nav.home')}
                                </a>
                            </li>
                            <li>
                                <a href="#" className="active">
                                    {t('nav.ourServices')}
                                </a>
                            </li>
                            <li>
                                <a href="#" className="active">
                                    {t('nav.aboutUs')}
                                </a>
                            </li>
                            <li>
                                <a href="#" className="active">
                                    {t('nav.ourTeam')}
                                </a>
                            </li>
                            <li>
                                <a href="#" onClick={handleDownloadEnglishProfile} className="active">
                                    {t('footer.companyProfile')} - English
                                </a>
                            </li>
                            <li>
                                <a href="#" onClick={handleDownloadArabicProfile} className="active">
                                    {t('footer.companyProfile')} - العربية
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className='col-lg-4 col-md-4 col-12'>
                    <div className='contact-details'>
                        <div className='details'>
                            <div className='contact-item'>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                    <path d="M22 12c0 5.5-4.5 10-10 10S2 17.5 2 12 6.5 2 12 2s10 4.5 10 10Z" stroke="currentColor" strokeWidth="2"/>
                                    <path d="M12 6v6l4 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                <a href='https://maps.app.goo.gl/Z9mPQPq5pYtkRCgD8?g_st=iwb' target='_blank' rel="noopener noreferrer" aria-label="Open location on Google Maps">
                                    {t('footer.location')}
                                </a>
                            </div>
                            <div className='contact-item'>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                    <path d="M22 16.92v2a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.92 4.18 2 2 0 0 1 4.92 2h2a2 2 0 0 1 2 1.72c.12.9.3 1.77.55 2.61a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.47-1.47a2 2 0 0 1 2.11-.45c.84.25 1.71.43 2.61.55A2 2 0 0 1 22 16.92Z" stroke="currentColor" strokeWidth="2"/>
                                </svg>
                                <a href='tel:+971568069823' aria-label="Call +971 55 288 3740">
                                    +971568069823
                                </a>
                            </div>
                            <div className='contact-item'>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                    <path d="M22 16.92v2a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.92 4.18 2 2 0 0 1 4.92 2h2a2 2 0 0 1 2 1.72c.12.9.3 1.77.55 2.61a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.47-1.47a2 2 0 0 1 2.11-.45c.84.25 1.71.43 2.61.55A2 2 0 0 1 22 16.92Z" stroke="currentColor" strokeWidth="2"/>
                                </svg>
                                <a href='tel:+971567805342' aria-label="Call +971 56 780 5342">
                                    +971567805342
                                </a>
                            </div>
                            <div className='contact-item'>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                    <path d="M4 4h16v16H4z" stroke="currentColor" strokeWidth="2"/>
                                    <polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                <a href='mailto:Info@etqanvision.com' target='_blank' rel="noopener noreferrer" aria-label="Email us at Info@etqanvision.com">
                                    Info@etqanvision.com
                                </a>
                            </div>
                        </div>
                    </div>
                    {/* Mobile-only social links placed under contact details */}
                    <div className='social-links social-mobile' aria-label="Social media links">
                        <ul>
                            <li>
                                <a href="https://www.youtube.com/@EtqanvisionEtqanvision" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                        <path d="M23.5 6.2a4 4 0 0 0-2.8-2.8C18.9 3 12 3 12 3s-6.9 0-8.7.4A4 4 0 0 0 .5 6.2 41.6 41.6 0 0 0 0 12c0 5.8.5 5.8.5 5.8a4 4 0 0 0 2.8 2.8C5.1 21 12 21 12 21s6.9 0 8.7-.4a4 4 0 0 0 2.8-2.8c.4-1.8.5-3.8.5-5.8 0-2-.1-4-.5-5.8Z" fill="currentColor"/>
                                        <path d="M9.75 15.02V8.98L15.5 12l-5.75 3.02Z" fill="#fff"/>
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.snapchat.com/add/etqanvision?share_id=fOX2-g_LNcc&locale=en-US" target="_blank" rel="noopener noreferrer" aria-label="Snapchat">
                                    <SiSnapchat size={22} aria-hidden="true" />
                                </a>
                            </li>
                            <li>
                                <a href="https://www.instagram.com/etqanvision" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                        <rect x="3" y="3" width="18" height="18" rx="5" stroke="currentColor" strokeWidth="2"/>
                                        <circle cx="12" cy="12" r="3.5" stroke="currentColor" strokeWidth="2"/>
                                        <circle cx="17.5" cy="6.5" r="1.2" fill="currentColor"/>
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <a href="http://tiktok.com/@etqan.vision.etqa" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
                                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                        <path d="M14.5 3v3.2c1.3 1.1 2.9 1.7 4.6 1.7v3a8.7 8.7 0 0 1-4.6-1.4v5.7a5.7 5.7 0 1 1-5.7-5.7c.4 0 .8 0 1.1.1V12a2.7 2.7 0 1 0 1.6 2.5V3h3Z" fill="currentColor"/>
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.facebook.com/profile.php?id=61580097365636" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                                    <SiFacebook size={22} aria-hidden="true" />
                                </a>
                            </li>
                            <li>
                                <a href="https://t.me/Etqanvision" target="_blank" rel="noopener noreferrer" aria-label="Telegram">
                                    <SiTelegram size={22} aria-hidden="true" />
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div className='footer-cr'>
            <div className='container'>
                <div className='footer-cr-row'>
                    <div className='footer-cr-item footer-cr-item-left'>
                        <img
                            src='/logo/dubai.png'
                            alt='دبي الاقتصاد والسياحة'
                            className='footer-cr-logo footer-cr-logo-large'
                        />
                        <p className='footer-cr-number'>2689091</p>
                    </div>
                    <div className='footer-cr-item'>
                        <img
                            src='/team/dubai-chamber-logo.svg'
                            alt='Dubai Chamber Logo'
                            className='footer-cr-logo'
                        />
                        <p className='footer-cr-number'>1546439</p>
                    </div>
                    <div className='footer-cr-item'>
                        <img
                            src='/team/unified.png'
                            alt='Unified Logo'
                            className='footer-cr-logo'
                            style={{ height: '60px' }}
                        />
                        <p className='footer-cr-number'>EP8452</p>
                    </div>
                </div>
            </div>
        </div>

        <div className='copy-right'>
            <h6> {t('footer.copyright')} </h6>
        </div>
    </footer>
  )
}

export default Footer;
